import type { InfoTriggerMobileInfo } from '@liveauctioneers/hammer-ui-liveauctioneers/estimateInfoTrigger';

import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { infoBottomSheetAtom } from '../infoBottomSheetAtoms';

export const useOpenInfoBottomSheet = () => {
    const setInfoBottomSheetState = useSetAtom(infoBottomSheetAtom);

    return useCallback(
        ({ content, title }: InfoTriggerMobileInfo) => {
            setInfoBottomSheetState({ content, isOpen: true, title });
        },
        [setInfoBottomSheetState]
    );
};
